import { html, TemplateResult, nothing } from 'lit';
import { runInAction } from 'mobx';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs.js';
import { comsStore } from '@src/state/ComsStore.js';
import { TefComs } from '@src/types/typings.js';

type KeysOfRef = keyof Omit<TefComs.Reference, 'state'>;

export function referenceItemTemplate(this: TefComs4csMicroFrontend, ref: TefComs.Reference): TemplateResult {
  const refVal = ref;

  const isFormDisabled = refVal.state !== 'inEdit';

  const isButtonDisabled = () => !(refVal.id && refVal.source && ref.type);

  const onChange = (e: { target: HTMLInputElement }) => {
    const name = e.target.name as KeysOfRef || undefined;
    if (name) {
      refVal[name] = e.target.value;
    }
  };

  const onDelete = (e: Event) => {
    e.preventDefault();
    runInAction(() => {
      comsStore.references = comsStore.references.filter((r) => r.id !== refVal.id);
    });
  };

  const onStartEdit = (e: Event) => {
    e.preventDefault();
    runInAction(() => {
      comsStore.references = comsStore.references.map(
        (r) => (r.id === refVal.id ? { ...r, state: 'inEdit' } : { ...r }),
      );
    });
  };

  const onSubmit = (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault();
    if (refVal.id) {
      runInAction(() => {
        comsStore.references = comsStore.references.filter((r) => r.id !== refVal.id);
        comsStore.references.push({ ...refVal, state: 'new' });
      });
    }
  };

  return html`
    <form @input=${onChange} @submit=${onSubmit}>
      <one-cluster x="space-between">
        <one-select
          options='[{"label":"Voice","value":"Voice"}]'
          name="type"
          ?disabled=${isFormDisabled}
          value="Voice"
        >
          <one-label slot="label">Typ</one-label>
        </one-select>

        <one-select
          options='[{"label":"CCT","value":"CCT"}]'
          name="source"
          ?disabled=${isFormDisabled}
          value="CCT"
        >
          <one-label slot="label">Quelle</one-label>
        </one-select>

        <one-input
          name="id"
          type="text"
          .value=${refVal.id}
          ?disabled=${isFormDisabled}
        >
          <one-label slot="label">Id</one-label>
        </one-input>

        ${ref.state === 'inEdit' ? html`
          <one-icon name="plus" size="l" cloak @click="${onSubmit}" ?disabled=${isButtonDisabled()}></one-icon>
        ` : nothing}
        ${ref.state === 'new' ? html`
          <one-icon name="edit" size="l" cloak @click="${onStartEdit}" ?disabled=${isButtonDisabled()}></one-icon>
          <one-icon name="trash" size="l" cloak @click="${onDelete}" ?disabled=${isButtonDisabled()}></one-icon>
        ` : nothing}
      </one-cluster>
    </form>
  `;
}
